import { Link } from "react-router-dom";
import type { PostItem } from "@/types/content";

export default function PostRow({ post, index }: { post: PostItem; index: number }) {
  return (
    <Link
      to={`/community/detail/${post.id}`}
      className="group flex w-full gap-3 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-secondary-300 md:gap-4 md:p-5"
    >
      <span
        className={`hidden h-9 w-9 shrink-0 items-center justify-center rounded-md text-sm font-medium sm:flex ${
          index < 3
            ? "bg-primary-100 text-primary-800"
            : "bg-background-100 text-foreground-500"
        }`}
      >
        {index + 1}
      </span>
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-2">
          {post.essence && (
            <span className="flex items-center gap-1 rounded-md bg-accent-100 px-1.5 py-0.5 text-[10px] font-medium text-accent-800">
              <i className="ri-award-line text-xs"></i>
              精华
            </span>
          )}
          <h3 className="line-clamp-2-custom text-sm font-medium leading-relaxed text-foreground-950 transition-colors group-hover:text-accent-700 md:text-base">
            {post.title}
          </h3>
        </div>
        <p className="line-clamp-2-custom mt-1.5 hidden text-xs leading-relaxed text-foreground-600 sm:block md:text-sm">
          {post.excerpt}
        </p>
        <div className="mt-2.5 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-500">
          <span className="flex items-center gap-1 whitespace-nowrap">
            <span className="flex h-5 w-5 items-center justify-center rounded-full bg-secondary-100 text-[10px] text-secondary-800">
              {post.author.slice(0, 1)}
            </span>
            {post.author}
          </span>
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-chat-3-line"></i>
            {post.replyCount} 回复
          </span>
          <span className="whitespace-nowrap text-foreground-400">最后更新 {post.updatedAt}</span>
        </div>
      </div>
      <i className="ri-arrow-right-s-line mt-1 hidden shrink-0 self-center text-xl text-foreground-300 transition-colors group-hover:text-accent-500 md:block"></i>
    </Link>
  );
}